export { default as GDMMenuItem } from './GDMMenuItem';

export type { GDMMenuItemComponent, GDMMenuItemProps } from './GDMMenuItem.type';
